// extracted by mini-css-extract-plugin
export default {"root":"ActionsInfoPanel_root__Mx6WU"};